// Getters
export const GET_STATUS = "promotion/GET_STATUS";
export const GET_STEPS = "promotion/GET_STEPS";
export const IS_COMPLETED = "promotion/IS_COMPLETED";
export const PROGRESS = "promotion/PROGRESS";

// Mutations
export const SET_INITIAL_DATA = "promotion/SET_INITIAL_DATA";

// Actions
export const INITIALIZE_PROMOTION = "promotion/INITIALIZE_PROMOTION";
export const SAVE_CHECKLIST_ITEM = "promotion/SAVE_CHECKLIST_ITEM";